import api from '../../../../../../admin/api/api';
import OT from '@opentok/client';

export default {
    namespaced: true,
    state: {
        apiKey: '',
        sessionId: '',
        token: '',
        streams: [],
        publisher: [],
        subscriber: [],
        users: [],
        sessionLoad: false,
        session: null,
        isVideo: true,
        isMic: true,
        mediaAccess: true,
        conferenceSetup: sessionStorage.getItem('conferenceSetup') ? JSON.parse(sessionStorage.getItem('conferenceSetup')) : null
    },
    mutations: {
        setOpenTokData(state, openTokData) {
            state.apiKey = openTokData.apiKey;
            state.sessionId = openTokData.sessionId;
            state.token = openTokData.token;
        },
        setMediaAccess(state, mediaAccess) {
            state.mediaAccess = mediaAccess;
        },
        setSession(state, session) {
            state.session = session;
        },
        setStream(state, stream){
            state.streams.push(stream);
        },
        spliceStream(state, stream){
            const idx = state.streams.indexOf(stream);

            if (idx > -1) {
                state.streams.splice(idx, 1);
            }
        },
        setUsers(state, users){
            state.users = users;
        },
        setUser(state, user){
            state.users.push(user);
        },
        spliceUser(state, user){
            state.users.splice(state.users.indexOf(user), 1);
        },
        setPublisher(state, publisher){
            state.publisher = publisher;
        },
        setSubscriber(state, subscriber){
            state.subscriber = subscriber;
        },
        switchVideo(state, statusVideo){
            state.isVideo = statusVideo;

            sessionStorage.setItem('conferenceSetup', JSON.stringify({
                isVideo: state.isVideo,
                isMic: state.isMic
            }));

            state.publisher.publishVideo(state.isVideo);
        },
        setSessionLoad(state, status) {
            state.sessionLoad = status;
        },
        switchMic(state, statusMic){
            state.isMic = statusMic;

            sessionStorage.setItem('conferenceSetup', JSON.stringify({
                isVideo: state.isVideo,
                isMic: state.isMic
            }));

            state.publisher.publishAudio(state.isMic);
        }
    },
    actions: {
        getOpenTokData({commit}){
            api.get('session')
                .then((response) => {
                    commit('setOpenTokData', response.data);
                })
                .catch((error) => {
                    alert(error.response.data.message);
                });
        },
        getSession({commit, state}){
            let session = OT.initSession(state.apiKey, state.sessionId);
            session.connect(state.token, (err) => {
                if (err) {
                    alert(err);
                }
            });
            commit('setSession', session);
        },
        endConference({state}, withMessage){
            if (withMessage) {
                ConfirmMessage.$emit('messageShow',
                    'Вы уверены, что хотите завершить консультацию? Если возникли проблемы со связью, воспользуйтесь кнопкой "Обновить страницу"',
                    'Обновить страницу',
                    'Завершить консультацию'
                );

                ConfirmMessage.$on('firstOption', () => {
                    return window.location.reload();
                });

                ConfirmMessage.$on('secondOption', () => {
                    sessionStorage.setItem('conferenceSetup', '');

                    api.post('end').then(response => {
                        state.session.disconnect();

                        return window.location.replace("/account/consultations/" + response.data.consultation.id);
                    }).catch(error => {
                        alert(error);
                    });
                });
            } else {
                api.post('end').then(response => {
                    state.session.disconnect();

                    return window.location.replace("/account/consultations/" + response.data.consultation.id);
                }).catch(error => {
                    alert(error);
                });
            }
        },
        publish({state}){
            state.session.publish(state.publisher);
        }
    }
}
